import { render, staticRenderFns } from "./publishPreview.vue?vue&type=template&id=0dbf6230"
import script from "./publishPreview.vue?vue&type=script&lang=js"
export * from "./publishPreview.vue?vue&type=script&lang=js"
import style0 from "./publishPreview.vue?vue&type=style&index=0&id=0dbf6230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports